import { ClerkProvider, useAuth, useClerk, useUser } from "@clerk/clerk-react";
import { Shell } from "./components/Shell";
import { StoreProvider } from "./state/store";
import { SignInScreen } from "./views/SignInScreen";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

export function App() {
  if (!publishableKey) {
    if (import.meta.env.DEV) {
      return (
        <StoreProvider userId="local" email="本地预览" devPreview getToken={null}>
          <Shell />
        </StoreProvider>
      );
    }
    return (
      <div className="gate">
        <div className="gate-card">
          <span className="logo-mark">准</span>
          <h1>还没配好登录</h1>
          <p>构建前要在环境变量里写上 VITE_CLERK_PUBLISHABLE_KEY。步骤在 README。</p>
        </div>
      </div>
    );
  }

  return (
    <ClerkProvider publishableKey={publishableKey}>
      <ClerkGate />
    </ClerkProvider>
  );
}

function ClerkGate() {
  const { isLoaded, isSignedIn, getToken } = useAuth();
  const { user } = useUser();
  const clerk = useClerk();
  if (!isLoaded) {
    return (
      <div className="gate">
        <p>正在确认登录…</p>
      </div>
    );
  }
  if (!isSignedIn || !user) return <SignInScreen />;
  return (
    <StoreProvider
      userId={user.id}
      email={user.primaryEmailAddress?.emailAddress ?? user.id}
      devPreview={false}
      getToken={() => getToken()}
      signOut={() => void clerk.signOut()}
    >
      <Shell />
    </StoreProvider>
  );
}
